import { render, staticRenderFns } from "./AboutInitiative.vue?vue&type=template&id=59abdfbc&scoped=true&"
import script from "./AboutInitiative.vue?vue&type=script&lang=js&"
export * from "./AboutInitiative.vue?vue&type=script&lang=js&"
import style0 from "./AboutInitiative.vue?vue&type=style&index=0&id=59abdfbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59abdfbc",
  null
  
)

export default component.exports